<template>
  <div v-if="article" class="news-detail-page">
    <Header light />

    <main>
      <div class="detail-hero">
        <div class="detail-hero-inner">
          <span>{{ article.tag }}</span>
          <h1>{{ article.title }}</h1>
          <p v-if="article.subtitle">{{ article.subtitle }}</p>
          <time>{{ article.date }}</time>
        </div>
      </div>

      <article class="article-content">
        <img
          class="article-cover"
          :src="article.image"
          :alt="article.title"
        />
        <p v-if="article.lead" class="article-lead">{{ article.lead }}</p>
        <section
          v-for="(section, sectionIndex) in article.sections"
          :key="section.heading || sectionIndex"
        >
          <h2 v-if="section.heading">{{ section.heading }}</h2>
          <p v-for="paragraph in section.paragraphs" :key="paragraph">
            {{ paragraph }}
          </p>
        </section>
        <div class="article-footer">
          <router-link :to="{ path: '/', hash: '#news' }"
            >返回新闻列表</router-link
          >
        </div>
      </article>
    </main>
    <Footer />
  </div>

  <main v-else class="article-not-found">
    <h1>新闻不存在</h1>
    <router-link to="/">返回首页</router-link>
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { findNewsBySlug } from "../data/news";
import Header from "../components/layout/Header.vue";
import Footer from "../components/layout/Footer.vue";

const route = useRoute();
const article = computed(() => findNewsBySlug(route.params.slug));
</script>
